import { resultFunc as ordersInProgress } from '@exodus/core-selectors/orders/orders-in-progress.js'
import { OrderSet } from '@exodus/models'

const resultFunction = (isRestoring, all) => {
  if (isRestoring) {
    return OrderSet.EMPTY
  }

  return ordersInProgress(all)
}

const OrdersInProgressSelectorDefinition = {
  id: 'ordersInProgress',
  resultFunction,
  dependencies: [{ module: 'application', selector: 'isRestoring' }, { selector: 'all' }],
}

export default OrdersInProgressSelectorDefinition
